<template>
  <div>
    <header-bar>
      {{ type === 'album' ? 'アルバム（2曲以上）': 'シングル' }}配信
    </header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">リリース情報登録 - リリース情報登録完了</h3>
      </div>
      <div class="page-block__inner">
        <div class="form-complete-area">
          <div class="form-complete-area__title">リリース情報登録完了</div>
          <div class="form-complete-area__lead">「{{ title }}」の配信審査を受付けました。</div>
          <div class="form-complete-area__text">審査完了後にあらためてメールにてご連絡いたしますので、今しばらくお待ちください。</div>
          <div class="c-btn-wrap">
            <a
              class="c-btn c-btn--back m-35"
              @click="cancelButton()">
              {{ isSubmitForm === 'true' ? 'サブミットを設定しない' : 'トップへ戻る' }}
              <span
                v-if="!isSubmitForm"
                class="c-btn__icon-arrow c-btn__icon-arrow--left">
              </span>
            </a>
            <a
              v-if="isSubmitForm === 'true'"
              class="c-btn m-35"
              @click="goToSubmitForm()">
              引き続きサブミットを設定する
            </a>
            <a
              v-if="isSubmitForm === 'false' && showCreateCopyrightButton()"
              class="c-btn m-35"
              @click="createCopyright()">
              引き続き著作権申請をする
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../HeaderBar'

export default {
  name: 'ReleaseCompleted',
  components: { HeaderBar },
  data() {
    return {
      title: null,
      type: 'album',
      isSubmitForm: false,
      trackId: null,
      isEligibleForCopyright: false,
    }
  },
  async mounted() {
    this.isSubmitForm = window.sessionStorage.getItem('submitReleaseForm')
    if (!window.sessionStorage.getItem('album')) {
      await this.$router.push({ name: 'index' })
      return
    }
    const release = JSON.parse(window.sessionStorage.getItem('album'))
    this.title = release.product.title_ja
    this.type = release.type
    if (this.type === 'single') {
      const { id } = release.discs[0].tracks[0]
      this.trackId = id
      await this.checkCopyrightEligibility()
    }
  },
  methods: {
    goToSubmitForm() {
      this.$router.push({ name: `${this.$route.meta.sideMenuId}-submit` })
    },
    cancelButton() {
      if (this.isSubmitForm === 'true') {
        this.$router.push({ name: `${this.$route.meta.sideMenuId}-submit-canceled` })
      } else {
        window.sessionStorage.removeItem('album')
        this.$router.push({ name: 'index' })
      }
    },
    createCopyright() {
      if (this.type === 'single') {
        this.$router.push({ name: 'get-track', params: { id: this.trackId } })
      } else {
        this.$router.push({ name: 'copyright-index' })
      }
    },
    showCreateCopyrightButton() {
      return (this.isBtoC && this.type === 'album') ? true
        : (this.isBtoC && this.type === 'single' && this.isEligibleForCopyright)
    },
    async checkCopyrightEligibility() {
      const { data } = await window.axios.get(`/api/client/copyrights/check-eligible/${this.trackId}`)
      this.isEligibleForCopyright = data.is_eligible ?? false
    },
  },
}
</script>
